import React from 'react';
import { Tooltip } from 'ui/common/tooltip/tooltip';
import { ComplexValue } from 'ui';
import { BlobMalwareScanStatus } from 'ui/file-uploader/file';
import styles from 'ui/file-uploader/file-uploader.scss';
import { toAbsoluteUrl } from 'app/infrastructure/hosting';
import { escapeUrl } from 'app/components/favourite-layout/favourite/common/utils';
import { convertNumericColorToHex } from 'app/infrastructure/universal/color';

export interface MalwareScanStatusValue {
  value: BlobMalwareScanStatus;
  valueItem: ComplexValue<BlobMalwareScanStatus>;
  valueItems: ComplexValue<BlobMalwareScanStatus>[];
}

export const MalwareScanStatus: React.FC<MalwareScanStatusValue> = ({ valueItem }) => {
  const iconSize = 18;
  const iconUrl = valueItem?.icon && toAbsoluteUrl(escapeUrl(valueItem?.icon));
  const title = valueItem?.description || '';
  const shouldRender = valueItem?.value !== BlobMalwareScanStatus.Unknown;
  const rgbColor = convertNumericColorToHex(valueItem?.backgroundColor || 0);

  return shouldRender ?
      <div className={`${styles.malwareScanStatus}`}>
        <Tooltip
          center={true}
          wide={true}
          className={styles.tooltip}
          title={valueItem?.longDescription}
        >
          <span
            role="img"
            aria-label={title}
            className={styles.malwareScanIcon}
            style={{
              width: `${iconSize}px`,
              height: `${iconSize}px`,
              backgroundColor: rgbColor,
              WebkitMask: `url(${iconUrl}) center / contain no-repeat`,
              mask: `url(${iconUrl}) center / contain no-repeat`
            }}
          />
          <span>{title}</span>
        </Tooltip>
      </div>
    : null;
};
